import React from 'react';

const ChartLine = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 384" width="16"><path d="M117.7,277.6a15.9,15.9,0,0,0,22.6,0L192,225.9l84.7,84.7a15.9,15.9,0,0,0,22.6,0L409.5,200.4,439,229.9c15.1,15.1,41,4.4,41-17V112a16,16,0,0,0-16-16H363.1c-21.4,0-32.1,25.8-17,41l29.5,29.5L288,254.1l-84.7-84.7a15.9,15.9,0,0,0-22.6,0l-74.4,74.3a16.1,16.1,0,0,0,0,22.6ZM496,400H48V80A16,16,0,0,0,32,64H16A16,16,0,0,0,0,80V416a32,32,0,0,0,32,32H496a16,16,0,0,0,16-16V416A16,16,0,0,0,496,400Z" transform="translate(0 -64)"/></svg>
  );
};

export default ChartLine;
